<div class="user-card">
  <div class="user-card-cover" [utBgImg]="profileBanner?.url || ''">
    @if (userPoints) {
      <span>{{ userPoints }}</span>
      } @if (userPoints) {
      <span>uPoints</span>
    }
  </div>
  @if (user.slug) {
    <a class="user-card-avatar" [uiSref]="'profile.about'" [uiParams]="{profileId: user.slug}">
      <div [utBgImg]="user.avatar_url || ''" class="profile-thumb xlarge"></div>
    </a>
  }
  <div class="user-card-content">
    @if (!user.slug) {
      <div [utBgImg]="user.avatar_url || ''" class="profile-thumb xlarge"></div>
    }
    <h4>
      @if (user.slug) {
        <a [uiSref]="'profile.about'" [uiParams]="{profileId: user.slug}">{{ user.name }}</a>
      }
      @if (!user.slug) {
        <span>{{ user.name }}</span>
      }
    </h4>
    <p>
      @if (user.slug) {
        <strong>&#64;{{ user.slug }}</strong>
      }
      @if (user.country?.name) {
        <small>{{ user.country.name }}</small>
      }
    </p>
    @if (canFollow) {
      <ut-community-follow-btn [user]="user"></ut-community-follow-btn>
    }
  </div>
</div>
